import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-foxpro-migration',
  templateUrl: './foxpro-migration.component.html',
  styleUrls: ['./foxpro-migration.component.scss']
})
export class FoxproMigrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
